// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__z7+I3 utils_fullscreen__FdaLC","backdrop":"Modal_backdrop__xTnIT utils_fullscreen__FdaLC","main":"Modal_main__ebL9o","close":"Modal_close__V34Fj"};